import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import '../../src/styles/LoadingOverlay.css';

interface LoadingOverlayProps {
  isLoading?: boolean;
  isMutating: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading = false,
  isMutating = false,
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isLoading || isMutating);
  }, [isLoading, isMutating]);

  return show ? (
    <div className="overlay">
      <Spinner animation="border" role="status" variant="primary" />
    </div>
  ) : null;
};

export default LoadingOverlay;
